// src/App.jsx
import React, { useEffect, useState, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Sidebar from './components/Sidebar';
import PremiumGuard from './components/PremiumGuard'; 
import AuthComponent from './components/AuthComponent';
import OrientationPrompt from './components/OrientationPrompt';
import Analytics from './components/Analytics';
import GoogleAdsTracker from './components/googleadstracker';
import { ConsentProvider } from './components/consent_banner/ConsentContext';
import CookieConsentBanner from './components/consent_banner/CookieConsentBanner';
import { 
  routes, 
  getPublicRoutes, 
  getAuthRoutes, 
  getPremiumRoutes 
} from './config/routes';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
  </div>
);

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  return (
    <ConsentProvider>
    <Router>
      <Analytics />
      <GoogleAdsTracker />
       <CookieConsentBanner />
       <OrientationPrompt />
      <div className="flex">
        <Sidebar user={user} />
        <main className="flex-1 ml-16 transition-all duration-300">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Public Routes */}
              {getPublicRoutes().map(({ path, component: Component }) => (
                <Route key={path} path={path} element={<Component />} />
              ))}

              {/* Auth Routes */}
              {getAuthRoutes().map(({ path, component: Component }) => (
                <Route 
                  key={path} 
                  path={path} 
                  element={user ? <Component /> : <AuthComponent />} 
                />
              ))}

              {/* Premium Routes */}
              {getPremiumRoutes().map(({ path, component: Component }) => (
                <Route 
                  key={path} 
                  path={path} 
                  element={
                    <PremiumGuard>
                      <Component />
                    </PremiumGuard>
                  } 
                />
              ))}
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
    </ConsentProvider>
  );
}

export default App;